module.exports = __webpack_public_path__ + "static/media/tick-bullet.85bf0def.svg";